import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Switch,
  TextField,
  IconButton,
  Button,
  makeStyles,
  Typography,
  CircularProgress,
  Grid,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import StyledButton from "../../../common/models/Button";
import { appUrl } from "../../../../utils/config";
import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: theme.spacing(2),
  },
  table: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    width: "650px",
  },
  headerCell: {
    fontWeight: 600,
    color: "#333",
    backgroundColor: "#f0f0f0",
    padding: "10px 16px",
    textAlign: "left",
  },
  bodyCell: {
    padding: "10px 16px",
    textAlign: "left",
    verticalAlign: "middle",
  },
  textField: {
    "& input": {
      padding: "6px 8px",
      height: "30px",
    },
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #000",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  deleteIcon: {
    color: theme.palette.error.main,
  },
  switchBase: {
    "&.Mui-checked": {
      color: "#007bff",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#007bff",
    },
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginTop: theme.spacing(4),
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "8px",
    gap: "4px",
  },
  iconBtn: {
    padding: "2px",
  },
  saveButton: {
    backgroundColor: "#EC6535",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#993d13",
    },
  },
  backButton: {
    backgroundColor: "#707070",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#4d4d4d",
    },
  },
}));

const ShipmentStatusTab = (props) => {
  const { addSponsorList, rowData,rowNetwork,updateNetworkData } = props;
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isUpdated, setIsUpdated] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [shipmentStatuses, setShipmentStatuses] = useState([]);
  const [savingStates, setSavingStates] = useState({});
  const [isSaving, setIsSaving] = useState(false); // Track save & next button loading

    const network=addSponsorList?.data?.network || rowNetwork;
   const networkUrl=updateNetworkData?.ecosystemUrl || rowData?.networkURL;

  const fetchShipmentStatuses = async () => {
    setError(null); // Reset error state
    setLoading(true); // Show loading spinner

    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchFGStatuses/false`; // API endpoint
      const response = await axios.get(url);
      const data = response?.data?.data;


      if (response.data?.status === true || response.data?.status === "true") {
        const list = data?.shipmentStatuses || [];

        // Map the API response to match the expected structure
        const formattedStatuses = list.map((item, index) => ({
          id: item.status_id || `ID-${index + 1}`, // Use ID from API or generate one
          name: item.status_name || "", // Use name from API or fallback
          selected: !!item.activated, // Convert activation state to boolean
          type: item.status_type,
          isNew: false, // Default to false for fetched statuses
        }));

        setShipmentStatuses(formattedStatuses); // Update state with formatted statuses
      } else {
        console.error(
          "Failed to fetch shipment statuses:",
          response.data?.message
        );
        setError(
          response.data?.message || "Failed to fetch shipment statuses."
        );
      }
    } catch (error) {
      console.error("Error fetching shipment statuses:", error);
      setError("An error occurred while fetching shipment statuses.");
    } finally {
      setLoading(false); // Hide loading spinner
    }
  };
  useEffect(() => {
    fetchShipmentStatuses();
  }, []);

  const addShipmentStatuses = async (index) => {
    if (savingStates[index]) return;
    setSavingStates((prev) => ({ ...prev, [index]: true }));
    try {
      const statusToAdd = shipmentStatuses[index]; // Get the status to add
      if (!statusToAdd.name.trim()) {
        setError("Please provide a name for the Shipment status.");
        setSavingStates((prev) => ({ ...prev, [index]: false }));
        return;
      }

      // Prepare the payload for the API
      const payload = {
        ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
      sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
        saslBatchStatusesList: [
          {
            // status_id: statusToAdd.id, // Use the ID if available, otherwise null
            status_name: statusToAdd.name, // Name of the Shipment status
            status_type: "New", // Mark as a new status
            object_type: "Shipment", // Set the object type to "Shipment"
            markForDelete: false,
            activated: statusToAdd.selected, // Default to false if not set
          },
        ],
      };


      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/addSASLBatchStatuses`; // API endpoint
      const response = await axios.post(url, payload);

      if (response.data?.status === true || response.data?.status === "true") {
        fetchShipmentStatuses();
        props.setShipmentStatus((prev) => !prev);
        // Update the state to mark the status as saved
        setShipmentStatuses((prev) =>
          prev.map((status, i) =>
            i === index
              ? { ...status, id: response.data?.data?.id, isNew: false }
              : status
          )
        );
      } else {
        console.error("Failed to add Shipment status:", response.data?.message);
        setError(response.data?.message || "Failed to add Shipment status.");
      }
    } catch (error) {
      console.error("Error adding Shipment status:", error);
      setError("An error occurred while adding the Shipment status.");
    }
    setSavingStates((prev) => ({ ...prev, [index]: false }));
  };

  const handleNextClick = async () => {
    try {
      // Validate that at least one shipment status is selected
      const isAnyStatusSelected = shipmentStatuses.filter(
        (status) => status.isUpdated
      );
      if (!isAnyStatusSelected.length) {
        props.handleNext(); // Directly move to the next tab
        return;
      }
      // if (!isAnyStatusSelected.length) {
      //   setErrorMessage("Please activate at least one shipment status.");
      //   console.log("Validation failed: No shipment status selected");
      //   return;
      // }
      if (shipmentStatuses.every((status) => !status.selected)) {
        setErrorMessage("Please enable at least one in toggle mode.");
        return;
      }

      setIsSaving(true); // Start loading

      // Prepare the payload for the API
      const payload = {
        ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
      sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
        shipmentStatuses: isAnyStatusSelected.map((status) => ({
          status_id: status.id, // ID of the shipment status
          status_name: status.name, // Name of the shipment status
          activated: status.selected, // Activation state
          newStatusName: status.newName, // New name if updated
          status_type: status.type, // Mark as a new status
          object_type: "Shipment",
          markForDelete: false, // Default to false
        })),
        batchStatuses: [], // Empty for this tab
        poStatuses: [], // Empty for this tab
      };


      // Call the API
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updateFGStatuses`;
      const response = await axios.post(url, payload);

      // Handle API response
      if (response.data?.status === true || response.data?.status === "true") {

        // Refresh the shipment statuses
        await fetchShipmentStatuses();

        // Move to the next tab
        if (props.handleNext) {
          props.handleNext();
        }
      } else {
        console.error(
          "Failed to update shipment statuses:",
          response.data?.message
        );
        setErrorMessage(
          response.data?.message || "Failed to update shipment statuses."
        );
      }
    } catch (error) {
      console.error("Error updating shipment statuses:", error);
      setErrorMessage(
        "An error occurred while updating shipment statuses. Please try again."
      );
    } finally {
      setIsSaving(false); // Stop loading
    }
  };

  const handleDelete = async (index) => {
    try {
      const statusToDelete = shipmentStatuses[index]; // Get the status to delete

      // If the status is new (not saved), delete it internally
      if (statusToDelete.isNew) {
        setShipmentStatuses((prev) => prev.filter((_, i) => i !== index));

        return;
      }

      // Prepare the payload for the API
      const payload = {
       ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
      sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
        shipmentStatuses: [
          {
            status_id: statusToDelete.id, // ID of the shipment status
            status_name: statusToDelete.name, // Name of the shipment status
            activated: statusToDelete.selected, // Current activation state
            newStatusName: statusToDelete.newName,
            markForDelete: true, // Mark the status for deletion
            status_type: statusToDelete.type, // Mark as a new status
            object_type: "Shipment",
          },
        ],

        batchStatuses: [], // Empty for this tab
        poStatuses: [], // Empty for this tab
      };


      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updateFGStatuses`; // API endpoint
      const response = await axios.post(url, payload);

      if (response.data?.status === true || response.data?.status === "true") {
        await fetchShipmentStatuses();
        props.setShipmentStatus((prev) => !prev);
        // Update the state to remove the deleted status
        setShipmentStatuses((prev) => prev.filter((_, i) => i !== index));
      } else {
        console.error(
          "Failed to delete Shipment status:",
          response.data?.message
        );
        setError(response.data?.message || "Failed to delete Shipment status.");
      }
    } catch (error) {
      console.error("Error deleting Shipment status:", error);
      setError("An error occurred while deleting the Shipment status.");
    }
  };

  const handleToggle = (index) => {
    const updated = [...shipmentStatuses];
    updated[index].selected = !updated[index].selected;
    updated[index].isUpdated = true;
    setShipmentStatuses(updated);
    setIsUpdated(true);
  };

  const handleNameChange = (index, value) => {
    const updated = [...shipmentStatuses];
    updated[index].name = value;
    setShipmentStatuses(updated);
  };

  // const handleDelete = (index) => {
  //   const updated = shipmentStatuses.filter((_, i) => i !== index);
  //   setShipmentStatuses(updated);
  // };

  const handleAddStatus = () => {
    //const nextId = (shipmentStatuses.length + 1).toString().padStart(2, "0");
    setShipmentStatuses([
      ...shipmentStatuses,
      {
        // id: nextId,
        name: "",
        selected: false,
        isNew: true,
      },
    ]);
  };

  // const handleCancel = (index) => {
  //   setShipmentStatuses((prev) =>
  //     prev.map((status, i) =>
  //       i === index
  //         ? {
  //             ...status,
  //             isEditing: false,
  //             name: status.originalName || status.name,
  //           }
  //         : status
  //     )
  //   );
  // };
  const handleCancel = (index) => {
    const statusToCancel = shipmentStatuses[index];

    // If the status is new, remove it from the state
    if (statusToCancel.isNew) {
      setShipmentStatuses((prev) => prev.filter((_, i) => i !== index));
      return;
    }

    // If the status is not new, revert its changes
    setShipmentStatuses((prev) =>
      prev.map((status, i) =>
        i === index
          ? {
              ...status,
              isEditing: false, // Reset editing state
              name: status.originalName || status.name, // Revert to original name
            }
          : status
      )
    );
  
  };

  return (
    <div className={classes.container}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.headerCell}>Selection</TableCell>
            <TableCell className={classes.headerCell}>
              Shipment Status
            </TableCell>
            <TableCell className={classes.headerCell}>
              Shipment Status ID
            </TableCell>
            <TableCell className={classes.headerCell}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            // Show loading spinner when loading is true
            <TableRow>
              <TableCell colSpan={4}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100px",
                  }}
                >
                  <CircularProgress />
                </div>
              </TableCell>
            </TableRow>
          ) : error ? (
            // Show error message when error exists
            <TableRow>
              <TableCell colSpan={4}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "60px",
                    backgroundColor: "#ffecec",
                    color: "#b00020",
                    border: "1px solid #ff9999",
                  }}
                >
                  <Typography>{error}</Typography>
                </div>
              </TableCell>
            </TableRow>
          ) : shipmentStatuses.length === 0 ? (
            // Show "No Data" message when batchStatuses is empty
            <TableRow>
              <TableCell colSpan={4}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "60px",
                    color: "#666",
                  }}
                >
                  <Typography>No Batch Statuses Found</Typography>
                </div>
              </TableCell>
            </TableRow>
          ) : (
            // Render shipmentStatuses data when available
            shipmentStatuses.map((item, index) => (
              <TableRow key={item.id}>
                <TableCell className={classes.bodyCell}>
                  <Switch
                    checked={item.selected}
                    onChange={() => handleToggle(index)}
                    classes={{ switchBase: classes.switchBase }}
                  />
                </TableCell>
                <TableCell className={classes.bodyCell}>
                  {item.isNew ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <TextField
                        placeholder="Type Text Here"
                        value={item.name}
                        onChange={(e) =>
                          handleNameChange(index, e.target.value)
                        }
                        onBlur={(e) => {
                          const trimmed = e.target.value.trim();
                          if (trimmed !== e.target.value) {
                            handleNameChange(index, trimmed);
                          }
                        }}
                        className={classes.textField}
                        variant="outlined"
                        inputProps={{
                          onBeforeInput: (e) => {
                            const allowedChars = /^[a-zA-Z0-9\s\-()]+$/;
                            if (!allowedChars.test(e.data)) {
                              e.preventDefault();
                            }
                          }
                        }}
                      />
                      <div className={classes.inlineActions}>
                        <IconButton
                          onClick={() => handleCancel(index)}
                          className={classes.iconBtn}
                        >
                          <CancelIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          onClick={() => addShipmentStatuses(index)}
                          className={classes.iconBtn}
                          disabled={
                            !item.name?.trim() ||
                            shipmentStatuses.some(
                              (s, i) =>
                                i !== index &&
                                s.name?.trim().toLowerCase() === item.name?.trim().toLowerCase()
                            ) || savingStates[index]
                          }
                        >
                          <SaveIcon fontSize="small" />
                        </IconButton>
                      </div>
                    </div>
                  ) : (
                    item.name
                  )}
                </TableCell>
                <TableCell className={classes.bodyCell}>{item.id}</TableCell>
                <TableCell className={classes.bodyCell}>
                  {(item.isNew == true || item.type === "New") && (
                    <IconButton
                      aria-label="delete"
                      onClick={() => handleDelete(index)}
                    >
                      <DeleteIcon className={classes.deleteIcon} />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      {errorMessage && (
        <div style={{ color: "red", marginTop: 10 }} className="error-message">
          {errorMessage}
        </div>
      )}

      <Button
        variant="outlined"
        onClick={handleAddStatus}
        className={classes.addButton}
      >
        <span className={classes.addIconCircle}>+</span>
        Add New Shipment Status
      </Button>

      <div className={classes.footer}>
        <Grid
          className={classes.backButton}
          onClick={() => {
            props.handleBack();
          }}
        >
          <ChevronLeftIcon />
          Back
        </Grid>
        <Grid
          className={classes.saveButton}
          onClick={() => {
            if (isUpdated) {
              handleNextClick(); // Call API and move to the next tab if updates are made
            } else {
              props.handleNext(); // Directly move to the next tab if no updates are made
            }
          }}
          style={{
            opacity: isSaving ? 0.7 : 1,
            pointerEvents: isSaving ? 'none' : 'auto' 
          }}
        >
          {isSaving ? (
            <>
              <CircularProgress size={16} color="inherit" style={{ marginRight: '8px' }} />
              Saving...
            </>
          ) : (
            <>
              Save & Next
              <ChevronRightIcon />
            </>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default ShipmentStatusTab;
